import React from 'react';
import {Col, Row, Table} from 'antd';
import {connect} from 'react-redux';
import {getMasterReport} from '../../redux/actions/report/getMasterReport';
import {withRouter} from 'react-router-dom';
import currency from 'currency.js';
import {EyeOutlined} from '@ant-design/icons';
import {ParseIntAndFormat} from "./ParseIntAndFormat";

class MasterReport extends React.Component {
    componentDidMount() {
        const {
            match: {
                params: {
                    date,
                    smasterName
                }
            }
        } = this.props;
        this.props.onGetReport({date, smasterName, type: this.props.type});
    }

    render() {
        const {Column, ColumnGroup} = Table;
        return (
            <Row>
                <Col span={24} style={{
                    width: '100%',
                    overflowX: 'scroll',
                }}>
                    <Table
                        bordered
                        loading={this.props.loading}
                        dataSource={this.props.masters}>
                        <Column title="Master Name" dataIndex="masterName" key="masterName" align="center"/>

                        <ColumnGroup title="Company">
                            <Column title="Bet" dataIndex="smasterBetAmount"
                                    render={(text, record) => ParseIntAndFormat(record.smasterBetAmount ?? 0)}
                                    key="smasterBetAmount" align="right"/>
                            <Column title="Commission" dataIndex="smasterCommissionAmount"
                                    render={(text, record) => ParseIntAndFormat(record.smasterCommissionAmount)}
                                    key="smasterCommissionAmount" align="right"/>
                            <Column
                                title="W/L"
                                key="s_win_lose"
                                render={(text, record) => {
                                    let sum = currency(record.smasterBetAmount)
                                        .subtract(currency(record.smasterWinAmount))
                                        .subtract(currency(record.smasterCommissionAmount))
                                        .value;
                                    return ParseIntAndFormat(sum);
                                }
                                }
                                align="right"
                            />
                        </ColumnGroup>
                        <ColumnGroup title="Senior Master">
                            <Column title="Bet" dataIndex="masterBetAmount"
                                    render={(text, record) => ParseIntAndFormat(record.masterBetAmount)}
                                    key="masterBetAmount" align="right"/>
                            <Column title="Commission" dataIndex="masterCommissionAmount"
                                    render={(text, record) => ParseIntAndFormat(record.masterCommissionAmount)}
                                    key="masterCommissionAmount" align="right"/>
                            <Column
                                title="W/L"
                                key="p_win_lose"
                                render={(text, record) => {
                                    let sum = currency(record.masterBetAmount)
                                        .subtract(currency(record.masterWinAmount))
                                        .subtract(currency(record.masterCommissionAmount))
                                        .value;
                                    return ParseIntAndFormat(sum);
                                }
                                }
                                align="right"
                            />
                        </ColumnGroup>
                        <Column title="Action" key="action" align="center" render={
                            (text, record) => <EyeOutlined onClick={
                                () => this.props.history.push(`/report/daily/${this.props.match.params.date}/masters/${record.masterName}/agents`)
                            }/>
                        }/>
                    </Table>
                </Col>
            </Row>
        );
    }
}

const mapStateToProps = state => ({
    loading: state.report.loading,
    error: state.report.error,
    masters: state.report.master,
    type: state.report.type
})

const mapDispatchToProps = dispatch => ({
    onGetReport: (id) => dispatch(getMasterReport(id)),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MasterReport));